module.exports = __webpack_public_path__ + "static/visa-fondy-50929befc8c96a4b477f0477d6448b8d.svg";